import { RestApiResponse } from "./RestApi";
import { BaseResponseAttributes } from "../attributes/base-attributes";
import { BusinessBranchAttributes } from "../attributes/business-branch-attributes";
import BaseService from "./BaseService";
import { RaffleDrawAttributes } from "../attributes/raffle-draw-attributes";
import moment from "moment";
import { WinningPackageAttibutes } from "../attributes/winning-package-attibutes";
import {FilterState} from "../attributes/filters-state";
import {ExportTag} from "../screens/icip_admin_screen/components/ExportRaffleParticipantsWrapper";
import {getPersistedLanguage} from "../context/LanguageContext";

export class ICIPAdminService extends BaseService {
  static teamBusinessesMember(page?: number, filters?: FilterState): Promise<RestApiResponse<BaseResponseAttributes>> {
    let paramsObject = {page: page};

    if(filters) {
      paramsObject = {
        ...paramsObject,
        ...filters,
      };
    }

    return ICIPAdminService.getApiClient().get(`admin/team-members/businesses`, {
        params: paramsObject
      }
    );
  }

  static teamUsersMember(page?: number, filters?: FilterState): Promise<RestApiResponse<BaseResponseAttributes>> {
    let paramsObject = {page: page};

    if(filters) {
      paramsObject = {
        ...paramsObject,
        ...filters,
      };
    }

    return ICIPAdminService.getApiClient().get(`admin/team-members/users`, {
      params: paramsObject
    });
  }

  static businessBranches(
    businessId: number,
    page: number
  ): Promise<RestApiResponse<BaseResponseAttributes>> {
    return ICIPAdminService.getApiClient().get(
      `admin/businesses/${businessId}/branches?page=${page}`,
      {
        params: { page: page },
      }
    );
  }

  static async createBusinessBranch(
    data: BusinessBranchAttributes
  ): Promise<RestApiResponse<BaseResponseAttributes>> {
    return ICIPAdminService.getApiClient().post(
      `admin/business-branches/create`,
      data
    );
  }

  static async inviteBusinessBranchManager(
    managerEmail: string,
    businessBranchId: number
  ): Promise<RestApiResponse<BaseResponseAttributes>> {
    return ICIPAdminService.getApiClient().post(
      `admin/business-branches/invite-manager`,
      {
        business_branch_id: businessBranchId,
        manager_email: managerEmail,
      }
    );
  }

  static async transferFundToBusiness(
    businessId: number,
    walletType: number,
    amount: number
  ): Promise<RestApiResponse<BaseResponseAttributes>> {
    return ICIPAdminService.getApiClient().post(
      `admin/businesses/transfer-funds`,
      {
        business_id: businessId,
        wallet_type: walletType,
        amount: amount,
      }
    );
  }

  static async transferFundToUser(
    userId: number,
    walletType: number,
    amount: number
  ): Promise<RestApiResponse<BaseResponseAttributes>> {
    return ICIPAdminService.getApiClient().post(`admin/users/transfer-funds`, {
      user_id: userId,
      wallet_type: walletType,
      amount: amount,
    });
  }

  static async resetUserPin(
    userId: number,
    pinCode: string
  ): Promise<RestApiResponse<BaseResponseAttributes>> {
    return ICIPAdminService.getApiClient().put(`admin/users/reset-pin`, {
      user_id: userId,
      pin_code: pinCode,
    });
  }

  static async editBusinessDDiscount(
    businessId: number,
    data: any
  ): Promise<RestApiResponse<BaseResponseAttributes>> {
    return ICIPAdminService.getApiClient().put(
      `admin/businesses/edit-discounts`,
      {
        business_id: businessId,
        ...data,
      }
    );
  }

  static supportedCountries(
    page?: number
  ): Promise<RestApiResponse<BaseResponseAttributes>> {
    return ICIPAdminService.getApiClient().get(`admin/countries`, {
      params: { page: page },
    });
  }

  static updateRaffleDrawDate(
    date: moment.Moment
  ): Promise<RestApiResponse<BaseResponseAttributes>> {
    return ICIPAdminService.getApiClient().put(
      `admin/raffle-draw/settings/update-raffledraw-date`,
      { raffle_draw_date: date.utc().toISOString() }
    );
  }

  static setRaffleDrawWinnerCode(
    code: string
  ): Promise<RestApiResponse<BaseResponseAttributes>> {
    return ICIPAdminService.getApiClient().put(
      `admin/raffle-draw/settings/set-winner`,
      { raffle_code: code.toString() }
    );
  }

  static getRaffleSettings(): Promise<RestApiResponse<BaseResponseAttributes>> {
    return ICIPAdminService.getApiClient().put(
      `admin/raffle-draw/settings/get-raffledraw-settings`
    );
  }

  static getRaffleDraws(): Promise<RestApiResponse<BaseResponseAttributes>> {
    return ICIPAdminService.getApiClient().get(
      `admin/raffle-draws/get-raffledraws`
    );
  }

  static raffleDrawParticipantList(
    raffleDrawId: number,
    participantType?: number,
    page?: number
  ): Promise<RestApiResponse<BaseResponseAttributes>> {
    return ICIPAdminService.getApiClient().get(
      `admin/raffle-draws/${raffleDrawId}/get-participants`,
      {
        params: {
          participant_type: participantType,
          page: page,
        },
      }
    );
  }

  //Export participants
  static exportRaffleDrawParticipant(
    raffleDrawId: number,
    participantType: number
  ): Promise<RestApiResponse<BaseResponseAttributes>> {
    return ICIPAdminService.getApiClient().get(
      `admin/raffle-draws/${raffleDrawId}/export-participants`,
      {
        params: { participant_type: participantType },
      }
    );
  }

  //Import company participants
  static importCompanyParticipants(): Promise<RestApiResponse<BaseResponseAttributes>> {
    return ICIPAdminService.getApiClient().post(`admin/raffle-draws/import-company-participants`, {
      
    });
  }
  static getUserDetails(
    id: number,
    scopes = ""
  ): Promise<RestApiResponse<BaseResponseAttributes>> {
    return ICIPAdminService.getApiClient().get(`admin/users/${id}`, {
      params: { scopes: scopes },
    });
  }

  static getRaffleDrawInProgress(): Promise<
    RestApiResponse<BaseResponseAttributes>
  > {
    return ICIPAdminService.getApiClient().get(
      `admin/raffle-draws/get-raffle-draw-in-progress`
    );
  }

  static getSpecialRaffleDrawInProgress(): Promise<
    RestApiResponse<BaseResponseAttributes>
  > {
    return ICIPAdminService.getApiClient().get(
      `admin/raffle-draws/get-special-raffle-draw-in-progress`
    );
  }

  static async createDefaultRaffleDraw(
    data: any[]
  ): Promise<RestApiResponse<BaseResponseAttributes>> {
    return ICIPAdminService.getApiClient().post(
      `admin/raffle-draws/add/default`,
      data
    );
  }

  static async createSpecialRaffleDraw(
    data: any[]
  ): Promise<RestApiResponse<BaseResponseAttributes>> {
    return ICIPAdminService.getApiClient().post(
      `admin/raffle-draws/add/special`,
      data
    );
  }

  static async updateRaffleDraw(
    raffleDrawId,
    data: RaffleDrawAttributes
  ): Promise<RestApiResponse<BaseResponseAttributes>> {

    return ICIPAdminService.getApiClient().post(
      `admin/raffle-draws/${raffleDrawId}/update`,
      data
    );
  }

  static getWinningPackages(): Promise<
    RestApiResponse<BaseResponseAttributes>
  > {
    return ICIPAdminService.getApiClient().get(`admin/winning-package`);
  }

  static getRaffleDrawDetails(
    raffleDrawId
  ): Promise<RestApiResponse<BaseResponseAttributes>> {
    return ICIPAdminService.getApiClient().get(
      `admin/raffle-draws/${raffleDrawId}/get-details`
    );
  }

  static async addWinningPackages(
    data: WinningPackageAttibutes
  ): Promise<RestApiResponse<BaseResponseAttributes>> {
    return ICIPAdminService.getApiClient().post(
      `/admin/winning-package/add-new-winning-package`,
      {
        ...data,
        wallet_type: data["wallet_type"] !== "" ? +data["wallet_type"] : "",
      }
    );
  }

  static async updateWinningPackage(
    winningPackagesId: number,
    data: WinningPackageAttibutes
  ): Promise<RestApiResponse<BaseResponseAttributes>> {
    return ICIPAdminService.getApiClient().post(
      `admin/winning-package/${winningPackagesId}/update`,
      data
    );
  }

  static async generateWinners(
    specialRaffleDrawInProgressId: number,
    packageWinnersInfos: any[]
  ): Promise<RestApiResponse<BaseResponseAttributes>> {
    return ICIPAdminService.getApiClient().post(
      `admin/raffle-draws/${specialRaffleDrawInProgressId}/generate-winners`,
      packageWinnersInfos
    );
  }

  static async sendRemindSMS(
    raffleDrawId: number
  ): Promise<RestApiResponse<BaseResponseAttributes>> {
    return ICIPAdminService.getApiClient().get(
      `admin/raffle-draws/${raffleDrawId}/send-remind-sms`
    );
  }

  static async sendStartNotificationSMS(
    raffleDrawId: number
  ): Promise<RestApiResponse<BaseResponseAttributes>> {
    return ICIPAdminService.getApiClient().get(
      `admin/raffle-draws/${raffleDrawId}/send-start-notification-sms`
    );
  }

  static async getAdminUsers(): Promise<
    RestApiResponse<BaseResponseAttributes>
  > {
    return ICIPAdminService.getApiClient().get(`admin/users/get-admin-users`);
  }

  static async getAuthUser(): Promise<RestApiResponse<BaseResponseAttributes>> {
    return ICIPAdminService.getApiClient().get(`admin/users/get-auth-user`);
  }

  static async getGeneralSettingForRaffleDay(): Promise<
    RestApiResponse<BaseResponseAttributes>
  > {
    return ICIPAdminService.getApiClient().get(
      `general-settings/settings-for-raffle-day`
    );
  }

  static async allAdminUsers(): Promise<
    RestApiResponse<BaseResponseAttributes>
  > {
    return ICIPAdminService.getApiClient().get(`admin/users`);
  }

  static async addAdminUser(
    values: any
  ): Promise<RestApiResponse<BaseResponseAttributes>> {
    return ICIPAdminService.getApiClient().post(`admin/users/add`, values);
  }

  static async changeAdminPassword(
     data: any,
  ): Promise<RestApiResponse<BaseResponseAttributes>> {
    return ICIPAdminService.getApiClient().put(`auth/pin/reset-for-admin`, {
      ...data,
    });
  }

  static getWithdrawRequests(
    page?: number
  ): Promise<RestApiResponse<BaseResponseAttributes>> {
    return ICIPAdminService.getApiClient().get(`admin/withdraw-request`, {
      params: { page: page },
    });
  }

  static withdrawRequestValidation(
    businessWithdrawRequestId: number
  ): Promise<RestApiResponse<BaseResponseAttributes>> {
    return ICIPAdminService.getApiClient().put(
      `admin/withdraw-request/${businessWithdrawRequestId}/validate`
    );
  }

  static async sendFlashSms(data: any,): Promise<RestApiResponse<BaseResponseAttributes>> {
    return ICIPAdminService.getApiClient().post(`admin/flash-sms`, {
      ...data,
    });
  }

  static async raffleDrawParticipationResume(data: any,): Promise<RestApiResponse<BaseResponseAttributes>> {
    return ICIPAdminService.getApiClient().post(`admin/participation-resume`, {
      ...data,
    });
  }

  static async raffleDrawParticipationResumeExportation(tag: ExportTag, periods: any): Promise<RestApiResponse<BaseResponseAttributes>> {
    return ICIPAdminService.getApiClient().post(`admin/participation-resume-export`, {
      tag: tag,
      ...periods,
    });
  }

  static async sendPushNotification(data: any,): Promise<RestApiResponse<BaseResponseAttributes>> {
    return ICIPAdminService.getApiClient().post(`admin/send-push-notification`, {
      ...data,
    });
  }

  static adminActivities(page?: number): Promise<RestApiResponse<BaseResponseAttributes>> {
    let paramsObject = {page: page};

    return ICIPAdminService.getApiClient().get(`admin/activities/schemas`, {
      params: paramsObject
    });
  }
}

export default ICIPAdminService;
